import React from 'react';
import { Button } from 'react-bootstrap';
import withTranslations from '../../utils/HighOrderComponent';

const ButtonSave = (props) => {
  const { variant, disabled, gt, message, className } = props || {};
  const variantValue = variant || 'primary';
  const messageButton = message || gt.Button.save;
  return (
    <Button
      variant={variantValue}
      className={`col-md-6 m-auto ${className} `}
      type="submit"
      disabled={disabled}
    >
      {messageButton}
    </Button>
  );
};

export default withTranslations(ButtonSave);
